import { create } from "zustand";
import {
  finishFirstRun,
  isFirstRecordingDone,
  markFirstRecordingDone,
} from "@/lib/onboarding";
import { useAuthStore } from "@/store/auth.store";

interface PostOnboardingStoreState {
  done: boolean;
  markDone: () => void;
}

export const usePostOnboardingStore = create<PostOnboardingStoreState>()(
  (set) => ({
    done: isFirstRecordingDone(),
    markDone: (): void => {
      try {
        markFirstRecordingDone();
        finishFirstRun(useAuthStore.getState().userData?.public_id);
      } catch {
        // localStorage failures must never break a submit flow
      }
      set({ done: true });
    },
  }),
);
